import React, { FC, useState, useEffect, memo } from "../../../lib/teact/teact";
import InputText from "../../ui/InputText";
import { updateGiaThuongMienBac } from "../redux/contactsSlice";
import store from "../store";

type OwnProps = {
    item: any;
    index: number;
}
const HanMucItem: FC<OwnProps> = ({
    item,
    index,
}) => {
    function handleDataChange(e: React.ChangeEvent<HTMLInputElement>) {
        const { id, value } = e.currentTarget;
        let nValue = Number(value)
        if (isNaN(nValue))
            nValue = 0

        const payload = { index: index, fieldName: id, value: nValue }
        store.dispatch(updateGiaThuongMienBac(payload))
    }
    return (
        <div className="hanmuc-item-main">
            <div className="hanmuc-item-row1">
                {item.loaiCuocId}
            </div>
            <div className="hanmuc-item-row2">
                <InputText value={item.nhanMax} label="Nhận MAX"
                    id="nhanMax"
                    onChange={handleDataChange}
                />
                <InputText value={item.chuyenMax} label="Chuyển MAX"
                    id="chuyenMax"
                    onChange={handleDataChange} />
                <InputText value={item.khAn} label="% Khách thầu"
                    id="khAn"
                    onChange={handleDataChange} />
            </div>

        </div>
    );
};

export default memo(HanMucItem);